export class IndividualSocialTypeReferenceModel {
    public individualSocialTypeCode: string;
    public individualSocialTypeName: string;
    public sortSequence: number;
}